import { chatSocket } from './dataProvider/socket';
import { _dataProvider } from './dataProvider/DataProvider';
import { resetIdigestChatHostConfig, setIdigestChatHostConfig, type IdigestChatHostConfig } from './chatHost';
import { setIdigestChatLanguage } from './i18n';

export interface IdigestChatConfig {
  apiBaseUrl: string;
  getAccessToken: () => string | null;
  getDisplayName?: () => string | null;
  /**
   * Host UI language. Accepts chat codes (eng/cht/chs) or common host
   * aliases (US/CN, en, zh-CN, …). Chat keeps its own i18next instance.
   */
  language?: string | null;
  host?: Partial<IdigestChatHostConfig>;
}

let isConfigured = false;
let previousAccessToken: string | null = null;
let previousDisplayName: string | null = null;

export function configureIdigestChat(config: IdigestChatConfig) {
  _dataProvider.init(config.apiBaseUrl);

  if (!isConfigured) {
    previousAccessToken = localStorage.getItem('access_token');
    previousDisplayName = localStorage.getItem('displayName');
    isConfigured = true;
  }

  const token = config.getAccessToken();
  if (token) {
    localStorage.setItem('access_token', token);
  } else {
    localStorage.removeItem('access_token');
  }
  chatSocket.refreshSession();

  const displayName = config.getDisplayName?.() ?? null;
  if (displayName) {
    localStorage.setItem('displayName', displayName);
  }

  if (config.language != null && config.language !== '') {
    setIdigestChatLanguage(config.language);
  }

  if (config.host) {
    setIdigestChatHostConfig(config.host);
  }
}

export function cleanupIdigestChat() {
  chatSocket.closeSocket();
  if (!isConfigured) return;
  isConfigured = false;
  if (previousAccessToken !== null) {
    localStorage.setItem('access_token', previousAccessToken);
  } else {
    localStorage.removeItem('access_token');
  }

  if (previousDisplayName !== null) {
    localStorage.setItem('displayName', previousDisplayName);
  }

  resetIdigestChatHostConfig();
}

declare global {
  interface Window {
    ___socket?: { close: () => void };
  }
}

export type {
  IdigestChatHostConfig,
  JoinMeetingOptions,
  VineProfileLabels,
  VineProfileState,
  VineProfileUser
} from './chatHost';
